export const ProductSliderBubblesMock = {
  title: '<h2>Picot® te echa la mano</h2>',
  items: [
    {
      title: '<h3>Original</h3><span>Aliviánate el empanzone</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltd8be32d4eb051720/68ef6139128f1428e0291662/7501095451096_10PZA_SIDEC.png',
      mainImageAlt: 'Sal de Uvas Picot® Original',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt5f3bda2907cc542c/68ff88d11e463153792d5adb/1_(1).png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt06244c7ce2ad240f/68ff88d27c34e885cd9b253d/1_(2).png',
    },
    {
      title: '<h3>Sabores</h3><span>Aliviánate con sabor</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltcf9d050a72927027/68ef6139128f144fcb291666/7501058715937_FT_10PZA_SIDEC.png',
      mainImageAlt: 'Sal de Uvas Picot® Sabores',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      decorations: [
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8352dfdc3893b046/68ef6137128f148a6029165e/naranja.png',
          size: 90,
          top: '10%',
          left: '10%',
          dur: 2.8,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt0ca94a89e5139c0a/68ef6137ff0e36cc4b423fb4/fresa.png',
          size: 90,
          top: '50%',
          left: '15%',
          dur: 2.9,
          delay: 0.8,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltd4eb9d8ca79b33af/68ef614ee6c594705106d0f4/piña.png',
          size: 60,
          top: '10%',
          left: '20%',
          dur: 3,
          delay: 0.2,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt793fa53ed6a1dc09/68ef6137e47f56604265795e/naranja_(1).png',
          size: 100,
          bottom: '10%',
          left: '2%',
          dur: 3.1,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltfeb3a7ac8f8f1116/68ef6139ca9739483257cc5a/limon.png',
          size: 100,
          top: '0',
          right: '5%',
          dur: 3.2,
          delay: 0.2,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltf4ea6887295b7c54/68ef614dce5c6ecba68f2e29/piña_(1).png',
          size: 60,
          top: '38%',
          right: '10%',
          dur: 3.3,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltbeaaa1d519d210b5/68ef6139f1d41b93c6109613/fresa_(1).png',
          size: 80,
          bottom: '10%',
          right: '18%',
          dur: 3.4,
          delay: 0.2,
        },
      ],
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt3602e1ba114b247b/68ff88d1e8b9593838d4057e/SABORES_(1).png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt2666ce1a4394d310/68ff88d2e8b9597aebd40582/3.png',
    },
    {
      title: '<h3>Plus</h3><span>Aliviánate la cruda*</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt54797befd28ec2aa/6a042ffb14c0563a9971359f/PICOT-PLUS-CAJA-9S-RENDER_-_Rotado.png',
      mainImageAlt: 'Picot® Plus',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt5f3bda2907cc542c/68ff88d11e463153792d5adb/1_(1).png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt36b1a2bdae089a0b/68ff88d20473aa24c6361f99/2_(1).png',
    },
  ],
};

export const SymptomsSliderBubblesMock = {
  items: [
    {
      title: '<h3>Original</h3><span>Aliviánate el empanzone</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltd8be32d4eb051720/68ef6139128f1428e0291662/7501095451096_10PZA_SIDEC.png',
      mainImageAlt: 'Sal de Uvas Picot® Original',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt5f3bda2907cc542c/68ff88d11e463153792d5adb/1_(1).png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt06244c7ce2ad240f/68ff88d27c34e885cd9b253d/1_(2).png',
    },
    {
      title: '<h3>Sabores</h3><span>Aliviánate con sabor</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltcf9d050a72927027/68ef6139128f144fcb291666/7501058715937_FT_10PZA_SIDEC.png',
      mainImageAlt: 'Sal de Uvas Picot® Sabor Frutas Tropicales',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      decorations: [
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8352dfdc3893b046/68ef6137128f148a6029165e/naranja.png',
          size: 90,
          top: '10%',
          left: '10%',
          dur: 2.8,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt0ca94a89e5139c0a/68ef6137ff0e36cc4b423fb4/fresa.png',
          size: 90,
          top: '50%',
          left: '15%',
          dur: 2.9,
          delay: 0.8,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltd4eb9d8ca79b33af/68ef614ee6c594705106d0f4/piña.png',
          size: 60,
          top: '10%',
          left: '20%',
          dur: 3,
          delay: 0.2,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt793fa53ed6a1dc09/68ef6137e47f56604265795e/naranja_(1).png',
          size: 100,
          bottom: '10%',
          left: '2%',
          dur: 3.1,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltfeb3a7ac8f8f1116/68ef6139ca9739483257cc5a/limon.png',
          size: 100,
          top: '0',
          right: '5%',
          dur: 3.2,
          delay: 0.2,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltf4ea6887295b7c54/68ef614dce5c6ecba68f2e29/piña_(1).png',
          size: 60,
          top: '38%',
          right: '10%',
          dur: 3.3,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltbeaaa1d519d210b5/68ef6139f1d41b93c6109613/fresa_(1).png',
          size: 80,
          bottom: '10%',
          right: '18%',
          dur: 3.4,
          delay: 0.2,
        },
      ],
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt3602e1ba114b247b/68ff88d1e8b9593838d4057e/SABORES_(1).png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt2666ce1a4394d310/68ff88d2e8b9597aebd40582/3.png',
    },
    {
      title: '<h3>Sabores</h3><span>Aliviánate con sabor</span>',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt2274519aead0d172/69258a82cceca3497d39a532/Picot_deUvas_Manzana.png',
      mainImageAlt: 'Sal de Uvas Picot® Sabor Manzana',
      bubble:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1756344a03440f30/68ef61392c70f53be4a2a561/bubble.png',
      bubbleBG:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt246094a995002d2e/68ff522e1e4631bc522d58de/2.png',
      bgMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltb75af77ad5353c7f/69257fef8f97f57e2ec3923a/sabores02.png',
      mainImageMobile:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt91a21fb3153d5ad1/69259945908de10dee806a9f/4.png',
      decorations: [
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8589753fb3b7ce91/69257ffdacfca84202837d1c/red_apple01.png',
          size: 67,
          top: '2%',
          left: '20%',
          dur: 2.8,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltbf203d096b0f705d/69257ffd13be14dae4e86246/red-apple02.png',
          size: 34,
          top: '15%',
          left: '10%',
          dur: 2.9,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt542ee3306954335c/69257ffd6a0e54853f83fae3/red-apple03.png',
          size: 57,
          top: '23%',
          left: '19%',
          dur: 3.0,
          delay: 0.3,
          zIndex: 5,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltbb9beefde6a9f61c/69257ffdedc4cdb734e96c71/red-apple04.png',
          size: 42,
          top: '40%',
          left: '2%',
          dur: 3.1,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltee50bf43d37c6ad6/69257ffda38411b886861a02/red-apple05.png',
          size: 74,
          top: '60%',
          left: '8%',
          dur: 3.2,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt96fafa56d54eb853/69257ffd5bc6b833098a7aa1/red-apple06.png',
          size: 39,
          top: '80%',
          left: '15%',
          dur: 3.3,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt27bca2a3591d803a/69303dcfe16a28563fa770ec/green-apple01.png',
          size: 36,
          top: '13%',
          right: '13%',
          dur: 3.4,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt91a391157d482611/69303dcfc761fb011d83cf1d/green-apple02.png',
          size: 73,
          top: '22%',
          right: '18%',
          dur: 3.5,
          delay: 0.3,
          zIndex: 5,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8b71cc177f281da2/69303dcf30d0a6190c6cb9d5/green-apple03.png',
          size: 40,
          top: '40%',
          right: '10%',
          dur: 3.6,
          delay: 0.3,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt301b58accfb29a2b/69303dcf8919b16d1c712a32/green-apple04.png',
          size: 46,
          top: '60%',
          right: '21%',
          dur: 3.7,
          delay: 0.3,
          zIndex: 5,
        },
        {
          image:
            'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt85bf55e5186ef407/69303dcf458f372d847f6fbb/green-apple05.png',
          size: 64,
          top: '72%',
          right: '10%',
          dur: 3.8,
          delay: 0.3,
        },
      ],
    },
  ],
};

export const SintomasSliderMock = {
  items: [
    {
      name: 'Agruras',
      alt: 'Síntoma de Agruras',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt73a158373fde8a9b/691c3af8c70b832e249bbb87/agruras-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltc6fecb4b811c4897/691c3dce45c2c47c8f79076d/agruras-flip.jpg',
      ataque: '"Explosión picante", te quema más que la salsita de habanero​.',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Asidez',
      alt: 'Síntoma de Asidez',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt3c6764ad77786703/691c3af8459bf972012db2e7/acidez-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt50b33b5aac642cf5/691c3dce6a0e54dbcd83f0db/acidez-flip.jpg',
      ataque: '"Tsunami estomacal", te revuelca desde la panza hasta la garganta.​',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Indigestion',
      alt: 'Síntoma de Indigestion',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltf12719efb5de7fba/691c3af9bbb894675b631645/indigestion-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt562bff053cd94da8/691c3dcfc8b6338c76545b92/indigestion-flip.jpg',
      ataque: '"Don tripón", te aplica un martinete a la panza  dejándote sin ganas de moverte.​',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Pesadez',
      alt: 'Síntoma de Pesadez',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8a49718b5c0fa10f/691c3b0578e5ef28d3bb286e/pesadez-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blta2808dc3029533b9/691c3dce3286a76ff361740c/pesadez-flip.jpg',
      ataque: '"Plancha post-taquiza", te deja tieso en la silla, sin poder moverte.​',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Ardor estomacal',
      alt: 'Síntoma de Ardor estomacal',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltd9c6a4477849e01f/691c3af87590585505e9d4ed/ardor-estomacal-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt334a54ca6bb45bb4/691c3dcebbb89416f4631657/ardor-estomacal-flip.jpg',
      ataque: '"Llama estomacal", te prende bien recio y quema todo a su paso.​',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Sentirse Lleno',
      alt: 'Síntoma de Sentirse Lleno',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt8637e9051191a9ce/691c3b058c5f3b4ece03fa4f/sentirse-lleno-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt116de590668c1dd0/691c3dce7590586c23e9d4f9/sentirse-lleno-flip.jpg',
      ataque: '"Combo pesado", aquí nada baja, ni con la agüita de jamaica​.',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
    {
      name: 'Regurgitacion',
      alt: 'Síntoma de Regurgitacion',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltfe88dd816879a662/691c3af81851953d9c658759/regurgitacion-main.jpg',
      flipImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltae1febf11f2caff4/691c3dce1d42743fb36a63c4/regurgitacion-flip.jpg',
      ataque: '"La reversa", da golpes bajos, regresando esos taquitos a tu boca​.​',
      molestia: '🔥🔥🔥🔥🔥',
      debilidad: 'Sal de Uvas Picot​®',
    },
  ],
};

export const SintomasPicotSliderMock = {
  title: '<h2>Síntomas <span>con los que te echa la mano:​</span></h2>',
  items: [
    {
      title: 'Indigestión',
      alt: 'Síntoma de Indigestión',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blta7898401a4826d3e/69022c221e463114152d64c8/Indigestion_(1).png',
    },
    {
      title: 'Acidez',
      alt: 'Síntoma de Acidez',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt712b25138064024d/69022c223e16cbf16cfb910c/Indigestion_(2).png',
    },
    {
      title: 'Agruras',
      alt: 'Síntoma de Agruras',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt1a3eeb65e000fa9d/69022c21da17fd62542857be/Agruras_(1).png',
    },
    {
      title: 'Pesadez',
      alt: 'Síntoma de Pesadez',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt4b29aefa93904551/696a4efeee448322b7ec6808/pesadez.png',
    },
    {
      title: 'Regurgitación',
      alt: 'Síntoma de Regurgitación',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt03d75e7664b174f4/696a50db7ef1f68127589a10/regurgitacion.png',
    },
    {
      title: 'Sentirse lleno',
      alt: 'Síntoma de Sentirse lleno',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt5a0c5a262c5589db/696a4efe34206be8a465b073/ardor.png',
    },
    {
      title: 'Ardor',
      alt: 'Síntoma de Ardor',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/bltab86bf97d38dd5de/696a4efe734233eead4b6302/Rectangle_1.png',
    },
  ],
};

export const SintomasPicotPlusSliderMock = {
  title: '<h2>Síntomas <span>con los que te echa la mano:​</span></h2>',
  items: [
    {
      title: 'Indigestión',
      alt: 'Síntoma de Indigestión',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blta7898401a4826d3e/69022c221e463114152d64c8/Indigestion_(1).png',
    },
    {
      title: 'Dolor de cabeza',
      alt: 'Síntoma de Dolor de cabeza',
      mainImage:
        'https://eu-images.contentstack.com/v3/assets/bltfd11845e39dafaec/blt056e0dae06ee731e/691d9bca51ecb1b7cca8c0e3/Dolor-de-cabeza.png',
    },
  ],
};
